import axios from "axios";
import {REDIRECT_TIMER_FINISH, REDIRECT_TIMER_START, SET_TOKEN, REMOVE_TOKEN} from "./types";

export default {
  /**
   * Redirect to a specific URL in the given number of seconds.
   *
   * The second value will be committed to the state so that the receiving component can display a countdown timer.
   *
   * NOTE: This does not do a history API or router.push, it changes the window location.
   *
   * @param commit
   * @param {Integer} seconds The number of seconds to wait before redirecting.
   * @param {String} to The URL to redirect to.
   * @returns {Promise<void>}
   */
  redirectIn({commit}, {seconds, to}) {
    commit(REDIRECT_TIMER_START, {seconds, to});

    const ms = seconds * 1000;
    setTimeout(() => {
      commit(REDIRECT_TIMER_FINISH, {seconds, to});
      window.location = to;
    }, ms);
  },

  async refreshToken({commit, state}) {
    const response = await axios({
      method: 'POST',
      url: `/auth/token/refresh`,
      data: {
        token: state.token
      }
    });

    console.log('refreshToken response:' + JSON.stringify(response));
    console.log('refreshToken token:' + JSON.stringify(response.data));
    commit(SET_TOKEN, response.data);
  },

  removeToken({commit, state}) {
    console.log('removeToken');
    commit(REMOVE_TOKEN,state);
  }
}
